export default "__VITE_ASSET__B7dWgD0K__"